// extracted by mini-css-extract-plugin
export default {"div":"Pd_div__IGDT5"};